// Copyright (c) 2020 Deere & Company

import FavoritesList, {getDefaultState as getFavoritesDefaultState} from '../state/favorites';
import actions from '../../../actions-list';

const readFavorites = (state, action) => FavoritesList.update(state, {
    $set: action.data
});

export default (state = getFavoritesDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_FAVORITES]: readFavorites
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
    state;

};



// WEBPACK FOOTER //
// ./src/shared/components/favorites/reducers/favorites.js